import {langService} from '../services/langService'
import {userService} from '../services/userService'

export function getStoreDef() {
    let user = userService.getInfo();
    return {
        user: {
            isLoggedIn: userService.isLoggedIn(),
            lang: langService.get(),
            id: user.id,
            login: user.login,
            addr: user.mfgId,
            name: user.name,
            email: user.email,
            lastName: user.lastName,
            isLoading: false,
            settings: user.settings,
            privileges: user.privileges,
        },
    };
}
